import $ from 'jquery'
import _ from 'lodash'
import cookies from '../../abt-utils/cookies'
import * as logger from '../../abt-utils/logger'
import * as pageData from '../../abt-utils/page-data'
import * as queryString from '../../abt-utils/query-string'

export function customCriteria (test, selector) {
  if (!$(selector).length) {
    logger.warn('ABT: ' + test.id + ' removed - no header')
    return
  }

  if (_excludeByPageData(test)) {
    logger.warn('ABT: ' + test.id + ' removed - excluded page')
    return
  }

  var isInQueryString = queryString.get('abt577')
  var hasUtCookie = cookies.get('abt577_ut')
  var remove = queryString.get('usability') === 'false'
  var isInTest = isInQueryString || (hasUtCookie && !remove)

  if (isInQueryString && !hasUtCookie) {
    _setUtCookie()
  }

  if (hasUtCookie && remove) {
    _deleteUtCookie()
  }

  if (!isInTest) {
    logger.warn('ABT: ' + test.id + ' removed - no url param or UT cookie')
  }

  return isInTest
}

function _excludeByPageData (test) {
  var errors = 0
  _.forOwn(test.customData.exclude, function (value, prop) {
    errors += pageData.contains(prop, value) ? 1 : 0
  })

  return errors > 0
}

function _setUtCookie () {
  var expiration = new Date()
  expiration.setDate(expiration.getDate() + 1)
  cookies.set('abt577_ut', 1, expiration)
}

function _deleteUtCookie () {
  cookies.set('abt577_ut', 0, new Date())
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-tests/abt577/shared.js
 ** module id = 20
 ** module chunks = 2
 **/